import { useAxios } from "../../utils/hooks";

interface Quota {
  code_name: string;
  has_limit: boolean;
  is_boolean: boolean;
  is_metered: boolean;
  unit: string;
}

interface Plan {
  name: string;
  amount: string;
  period: string;
  plan_quota: {
    quantity: number;
    is_boolean: boolean;
    quota: Quota;
  }[];
}

interface Subscription {
  start_date: string;
  validity: string;
  auto_renew: boolean;
  plan: Plan;
}

interface MeteredQuotaUsage {
  used_quantity: number;
  available_quantity: number;
  code_name: string;
}

interface QuotaUsage {
  code_name: string;
  used_quantity: number;
}

export interface SubscriptionResponse {
  subscription: Subscription;
  metered_quota_usage: MeteredQuotaUsage;
  quota_usage: QuotaUsage[];
  stripe_customer_portal: string;
}

const useSubscriptionDetails = async () => {
  const { response } = await useAxios({
    method: "GET",
    url: "/payments/subscription/details/",
  });
  return { response };
};

export default useSubscriptionDetails;
